<template>
    <div>
        <Header title="服务项目" memo="管理机构心理服务项目"></Header>
        <a-divider />
        <a-table :style="{ marginTop: '16px' }" :row-key="record => record.tag" :data-source="datas" :loading="loading" bordered :pagination="false">
            <a-table-column key="tag" ellipsis width="200px">
                <span slot="title">服务项目</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.tag | fmtUnitService }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="flag" ellipsis width="100px">
                <span slot="title">是否启用</span>
                <template slot-scope="text, record">
                    <span>
                        {{ record.flag ? '已启用' : '未启用' }}
                    </span>
                </template>
            </a-table-column>
            <a-table-column key="fee" ellipsis>
                <span slot="title">服务价格</span>
                <template slot-scope="text, record">
                    <span>{{ record.fee }} [ {{ record.memo }} ]</span>
                </template>
            </a-table-column>
            <a-table-column key="action" fixed width="200px">
                <span slot="title">操作</span>
                <template slot-scope="text, record">
                    <a-button type="link" icon="edit" @click="showEditForm(record)">
                        编辑
                    </a-button>
                </template>
            </a-table-column>
        </a-table>

        <FormComp title="编辑配置" :item="now" :show.sync="form" v-if="form" @doLoad="doLoad"></FormComp>
    </div>
</template>

<script>
import FormComp from './FormComp'

export default {
    name: 'UnitItems',
    components: {
        FormComp
    },
    computed: {
        loading() {
            return this.$store.state.Loading.flag && !this.$store.state.Loading.full
        }
    },
    data() {
        return {
            datas: [],
            form: false,
            now: {}
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['机构信息', '服务项目'])
        this.doLoad()
    },
    methods: {
        doLoad() {
            this.$http
                .get('/ums/unit/info/srv/items', {
                    params: {
                        _: new Date().getTime()
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.datas = result.datas
                })
        },
        showEditForm(item) {
            this.now = item
            this.form = true
        }
    }
}
</script>
